import DataAccessService from '@/services/api/DataAccessService'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'


export default {
  selectActiveEntity({commit}:any, id: number) {
    if (id === null) {
      commit('CLEAR_ACTIVE_ENTITY', id)
    } else {
      commit('SELECT_ACTIVE_ENTITY', id)
    }
  },
  resetStore({commit}:any) {
    commit('RESET_STORE')
  },
  setupFromLogin({commit}: any, loginPayload) {
    const service = DataAccessService.build(null)

    service.getDefaultEntity().then(
      response => {
        if (!isEmpty(response)) {
          console.info('Setting the default active data access entity.')
          commit('SELECT_ACTIVE_ENTITY', {
            id: get(response, 'entity.id'),
            type: get(response, 'entity_type')
          })
        } else {
          console.info('No defalt data access entity for the current user.')
        }
      },
      error => {
        alert('Não foi possível carregar o contexto ativo de dados.')
      }
    )
  }
}
